import { useApiStore } from "@/stores/api/index.ts";
import getDefaultOpts from "@/store/utils/getDefaultOpts.js";

const addEntry = async (module, { doc, categoryID, opts = {} }) => {
  const api = useApiStore();
  const { dispatch } = module;
  const config = Object.assign(getDefaultOpts(), opts);
  const res = await dispatch("httpRequest", {
    func: api.addEntry(categoryID, doc),
    config,
  });
  await dispatch("fetchCategory", { id: categoryID, opts });
  await dispatch("fetchCategories", { opts });
  return res;
};

export { addEntry };
